import genererConventionEtude from './conventionEtude/genererConventionEtude.js';
import genererDevis from './devis/genererDevis.js';
import genererPVRI from './pvri/genererPVRI.js';
import genererPVRF from './pvrf/genererPVRF.js';
import genererCahierDesCharges from './cdc/genererCahierDesCharges.js';

/**
 * Liste de tous les documents que l'application sait générer.
 * Le tableau de bord (VueTableauDeBord) affiche une carte par entrée.
 *
 * Pour ajouter un 5ème ou 6ème document :
 *  1. créer documents/monDocument/genererMonDocument.js (voir genererDevis.js
 *     comme modèle le plus simple)
 *  2. créer sa vue dans composants/vues/VueMonDocument.js
 *  3. ajouter une ligne ici
 *  4. ajouter une entrée dans VUES_DOCUMENTS (App.js)
 * → aucun autre fichier à toucher.
 */
export const DOCUMENTS = [
  {
    id: 'conventionEtude',
    label: "Convention d'étude",
    prefixeReference: 'CE',
    description: 'Cahier des charges, méthodologie, budget',
    generer: genererConventionEtude,
  },
  {
    id: 'devis',
    label: 'Devis',
    prefixeReference: 'Devis',
    description: "Chiffrage détaillé de l'étude",
    generer: genererDevis,
  },
  {
    id: 'pvri',
    label: 'PV de Recette Intermédiaire',
    prefixeReference: 'PVRI',
    description: 'Validation partielle en cours de mission',
    generer: genererPVRI,
  },
  {
    id: 'pvrf',
    label: 'PV de Recette Finale',
    prefixeReference: 'PVRF',
    description: "Clôture de l'étude",
    generer: genererPVRF,
  },
  {
    id: 'cdc',
    label: 'Cahier des charges',
    prefixeReference: 'CDC',
    description: "Cahier des charges de l'étude",
    generer: genererCahierDesCharges,
  }
];
